import React from 'react'
import {Grid, HStack, GridProps, useMultiStyleConfig} from '@chakra-ui/react'
import SearchResultsHeader from './search/results-header'
import EmptySearchResults from './search/empty-results'
import StoriesGrid from './search/stories-grid'

interface ProductListingProps {
    variant: 'grid3' | 'grid2' | 'wishlist'
    children: React.ReactNode
}

const ProductListing = React.memo(({variant, children}: ProductListingProps) => {
    const styles = useMultiStyleConfig('ProductListing', {variant}) as Record<string, GridProps>
    return (
        <HStack {...styles.wrapper}>
            <Grid {...styles.listWrapper} data-testid={`product-listing-${variant}`}>
                {children}
            </Grid>
        </HStack>
    )
})

ProductListing.displayName = 'ProductListing'

export {ProductListing, SearchResultsHeader, EmptySearchResults, StoriesGrid}
